import { defineMessages } from 'react-intl'

export const expertsFiltersMessages = defineMessages({
  'landscape-architecture': {
    id: 'components.searchExperts.landscapeArchitecture',
    defaultMessage: 'Landscape Architects & Landscape Designers'
  },
  'interior-design': {
    id: 'components.searchExperts.interiorDesign',
    defaultMessage: 'Interior Designers & Interior Architects'
  },
  'urban-planning': {
    id: 'components.searchExperts.urbanPlanning',
    defaultMessage: 'Urban Planners'
  },
  'engineering-consulting': {
    id: 'components.searchExperts.engineeringConsulting',
    defaultMessage: 'Engineers & Consultants'
  },
  'acoustic': {
    id: 'components.searchExperts.acoustic',
    defaultMessage: 'Acoustic Consultants & Acoustic Engineers'
  },
  'civil': {
    id: 'components.searchExperts.civil',
    defaultMessage: 'Civil Engineers'
  },
  'electrical': {
    id: 'components.searchExperts.electrical',
    defaultMessage: 'Electrical Engineers'
  },
  'environmental-sustainability': {
    id: 'components.searchExperts.environmentalSustainability',
    defaultMessage: 'Environmental Consultants & Environmental Engineers'
  },
  'lighting': {
    id: 'components.searchExperts.lighting',
    defaultMessage: 'Lighting Designers & Lighting Consultants'
  },
  'mechanical': {
    id: 'components.searchExperts.mechanical',
    defaultMessage: 'Mechanical Engineers'
  },
  'mep': {
    id: 'components.searchExperts.mep',
    defaultMessage: 'MEP Consultants & MEP Engineers'
  },
  'quantity-surveying': {
    id: 'components.searchExperts.quantitySurveying',
    defaultMessage: 'Quantity Surveyors'
  },
  'services': {
    id: 'components.searchExperts.services',
    defaultMessage: 'Services Engineers & Services Consultants'
  },
  'structural': {
    id: 'components.searchExperts.structural',
    defaultMessage: 'Structural Engineers'
  },
  'project-management': {
    id: 'components.searchExperts.projectManagement',
    defaultMessage: 'Project Managers'
  },
  'construction': {
    id: 'components.searchExperts.construction',
    defaultMessage: 'Construction Companies & Contractors'
  },
  'general-contracting': {
    id: 'components.searchExperts.generalContracting',
    defaultMessage: 'General Contractors'
  }
})

export const expertsFiltersDropdownMessages = defineMessages({
  'landscape-architecture': {
    id: 'components.searchExperts.filters.landscapeArchitecture',
    defaultMessage: 'Landscape Architects'
  },
  'interior-design': {
    id: 'components.searchExperts.filters.interiorDesign',
    defaultMessage: 'Interior Designers'
  },
  'urban-planning': {
    id: 'components.searchExperts.filters.urbanPlanning',
    defaultMessage: 'Urban Planners'
  },
  'engineering-consulting': {
    id: 'components.searchExperts.filters.engineeringConsulting',
    defaultMessage: 'Engineers & Consultants'
  },
  'acoustic': {
    id: 'components.searchExperts.filters.acoustic',
    defaultMessage: 'Acoustic Consultants'
  },
  'civil': {
    id: 'components.searchExperts.filters.civil',
    defaultMessage: 'Civil Engineers'
  },
  'electrical': {
    id: 'components.searchExperts.filters.electrical',
    defaultMessage: 'Electrical Engineers'
  },
  'environmental-sustainability': {
    id: 'components.searchExperts.filters.environmentalSustainability',
    defaultMessage: 'Environmental Consultants'
  },
  'lighting': {
    id: 'components.searchExperts.filters.lighting',
    defaultMessage: 'Lighting Designers'
  },
  'mechanical': {
    id: 'components.searchExperts.filters.mechanical',
    defaultMessage: 'Mechanical Engineers'
  },
  'mep': {
    id: 'components.searchExperts.filters.mep',
    defaultMessage: 'MEP Consultants'
  },
  'quantity-surveying': {
    id: 'components.searchExperts.filters.quantitySurveying',
    defaultMessage: 'Quantity Surveyors'
  },
  'services': {
    id: 'components.searchExperts.filters.services',
    defaultMessage: 'Services Engineers'
  },
  'structural': {
    id: 'components.searchExperts.filters.structural',
    defaultMessage: 'Structural Engineers'
  },
  'project-management': {
    id: 'components.searchExperts.filters.projectManagement',
    defaultMessage: 'Project Managers'
  },
  'construction': {
    id: 'components.searchExperts.filters.construction',
    defaultMessage: 'Construction Companies'
  },
  'general-contracting': {
    id: 'components.searchExperts.filters.generalContracting',
    defaultMessage: 'General Contractors'
  }
})

export const tagFiltersMessages = defineMessages({
  'art': {
    id: 'components.archiveFilters.art',
    defaultMessage: 'Art'
  },
  'circular_economy': {
    id: 'components.archiveFilters.circularEconomy',
    defaultMessage: 'Circular Economy'
  },
  'cities_urbanism': {
    id: 'components.archiveFilters.cities',
    defaultMessage: 'Cities & Urbanism'
  },
  'community': {
    id: 'components.archiveFilters.community',
    defaultMessage: 'Community'
  },
  'design': {
    id: 'components.archiveFilters.design',
    defaultMessage: 'Design'
  },
  'emergency_architecture': {
    id: 'components.archiveFilters.emergency_architecture',
    defaultMessage: 'Emergency Architecture'
  },
  'sustainability_environment': {
    id: 'components.archiveFilters.sustainability_environment',
    defaultMessage: 'Sustainability & Environment'
  },
  'future_of_architecture': {
    id: 'components.archiveFilters.future_of_architecture',
    defaultMessage: 'Future of Architecture'
  },
  'history_heritage': {
    id: 'components.archiveFilters.history_heritage',
    defaultMessage: 'History & Heritage'
  },
  'guides_how_to': {
    id: 'components.archiveFilters.guides_how_to',
    defaultMessage: 'Guides & How-to\'s'
  },
  'materials': {
    id: 'components.archiveFilters.materials',
    defaultMessage: 'Materials'
  },
  'public_policies': {
    id: 'components.archiveFilters.public_policies',
    defaultMessage: 'Public Policies'
  },
  'technology': {
    id: 'components.archiveFilters.technology',
    defaultMessage: 'Technology'
  }
})
